/**
 * Lee flow_token (o token / access_token) de la query, persiste en localStorage
 * y limpia la URL sin recargar. Prioridad: flow_token > token > access_token.
 * @returns {boolean} true si se aplicó un token desde la URL
 */
export function consumeFlowTokenFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw =
      params.get('flow_token') || params.get('token') || params.get('access_token');
    if (!raw || !String(raw).trim()) return false;
    const t = String(raw).trim();
    localStorage.setItem('sf_access_token', t);
    localStorage.setItem('access_token', t);
    localStorage.setItem('token', t);
    localStorage.setItem('spectra_token', t);
    window.history.replaceState({}, document.title, window.location.pathname);
    return true;
  } catch {
    return false;
  }
}
